<template>
  <div>
    
    <b-container>
      <b-row>
        <b-col>
          <card-conventions
            orientation="horizontal"
            :show-ideal="true"
            :show-company="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <card-chart-treemap alias="treemap" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <card-charts-indicator
            pillar-id="OP"
            indicator-id="OP1"
            alias="bar"
            height="450px"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <card-charts-indicator
            pillar-id="OP"
            indicator-id="OP2"
            alias="bar2"
            height="450px"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <card-charts-indicator
            pillar-id="PP"
            indicator-id="PP1"
            alias="barhorizontal"
            height="450px"
            orientation="horizontal"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <card-charts-indicator
            pillar-id="RSH"
            indicator-id="RSH1"
            alias="pie"
            height="450px"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <card-charts-indicator
            pillar-id="PDP"
            indicator-id="PDP1"
            alias="grouped"
            height="450px"
          />
        </b-col>
      </b-row>
      <!--<b-row>
        <b-col md="6">
          <card-charts-indicator pillar-id="R" indicator-id="R1" alias="stacked" height="450px"></card-charts-indicator>
        </b-col>
         <b-col md="6">
          <card-table-indicator pillar-id="R" indicator-id="R1" height="450px"></card-table-indicator>
        </b-col>
      </b-row>-->
    </b-container>
  </div>
</template>
<script>
export default {
  name: "ResourcesDownloads",
  data: function () {
    return {
      
    };
  },
  computed: {},
  created: function () {},
  methods: {},
};
</script>